import React from "react";
import { Box, styled, Typography } from "@mui/material";
import { formatTime } from "../utils/app-utils";

interface ChatBubbleProps {
  message: string;
  sender?: string;
  isSender: boolean;
  date: Date;
}

const Bubble = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isSender",
})<{ isSender: boolean }>(({ theme, isSender }) => ({
  maxWidth: "45%",
  minWidth: "20%",
  padding: "0.8rem 0.8rem 1.5rem",
  borderRadius: isSender
    ? `${theme.spacing(2)} ${theme.spacing(2)} 0 ${theme.spacing(2)}` // Rounded corners for sender
    : `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(2)} 0`, // Rounded corners for receiver
  backgroundColor: theme.palette.background.paper, // WhatsApp colors
  color: theme.palette.text.primary,
  marginLeft: isSender ? "auto" : "0",
  marginRight: !isSender ? "auto" : "0",
  marginBottom: theme.spacing(1),
  position: "relative",
}));

const ChatBubble: React.FC<ChatBubbleProps> = ({
  message,
  sender,
  isSender,
  date,
}) => {
  return (
    <Bubble isSender={isSender}>
      {sender && (
        <Typography variant="subtitle2" gutterBottom>
          {sender}
        </Typography>
      )}
      <Typography sx={{ fontSize: "14px" }} variant="body1">
        {message}
      </Typography>
      <Typography
        sx={{ position: "absolute", fontSize: "11px", bottom: 5, right: 10 }}
        variant="caption"
        display="block"
      >
        {formatTime(date)}
      </Typography>
    </Bubble>
  );
};

export default ChatBubble;
